var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyTank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 204,
    viewBox: "0 0 383 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273.175 187.613H261.577C259.027 187.613 256.951 185.537 256.951 182.987V176.279H252.246V182.987C252.246 188.133 256.431 192.318 261.577 192.318H273.175V187.613Z",
    fill: "#77787B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M261.82 178.081H247.218L210 114.119H299.038L261.82 178.081Z",
    fill: "#303039"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.896 117.511L249.169 174.689H252.704L222.838 117.511H215.896Z",
    fill: "#3F3F46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M231.95 117.511H225.805L254.966 174.689H256.661L231.95 117.511Z",
    fill: "#3F3F46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M299.038 45.891C299.038 52.3665 279.117 57.64 254.535 57.64C229.952 57.64 210.031 52.3665 210.031 45.891C210.031 39.8381 227.375 34.8532 249.686 34.2264C251.28 34.1584 252.89 34.1419 254.535 34.1419C256.18 34.1419 257.79 34.1584 259.384 34.2264C281.694 34.8532 299.038 39.8381 299.038 45.891Z",
    fill: "#515159"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.543 44.054H223.649C227.294 41.2626 235.365 38.1187 247.426 36.5519C228.838 37.3394 217.197 41.1018 213.543 44.054Z",
    fill: "#3F3F46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M251.617 36.4302C239.048 37.9538 230.674 41.1925 226.938 44.054H232.764C236.5 41.1925 244.874 37.9538 257.445 36.4302C256.485 36.4158 255.53 36.3973 254.537 36.3973C253.541 36.3973 252.582 36.4158 251.617 36.4302Z",
    fill: "#3F3F46"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M219.599 202.238H213.509V111.091H219.599V202.238Z",
    fill: "#77787B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M295.531 202.238H289.439V111.091H295.531V202.238Z",
    fill: "#77787B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M210.035 48.4245C210.012 48.6534 210 48.8864 210 49.1235V114.119H299.038V49.1235C299.038 48.8864 299.026 48.6534 299.003 48.4245H210.035Z",
    fill: "#515159"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M213.328 50.7502C213.295 50.9749 213.258 51.1996 213.258 51.4326V111.949H221.444V50.9563L221.459 50.7502H213.328Z",
    fill: "#3F3F46"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M224.514 50.7502L224.5 50.9563V111.949H230.437V50.9563L230.453 50.7502H224.514Z",
    fill: "#3F3F46"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M223.31 203.011H210V200.3H223.31V203.011Z",
    fill: "#444548"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M298.799 203.011H286.23V200.3H298.799V203.011Z",
    fill: "#444548"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M299.038 45.8868H210.035V48.4246H299.038V45.8868Z",
    fill: "#3F3F46"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M280.344 126.39C280.344 127.285 279.618 128.01 278.723 128.01C277.829 128.01 277.105 127.285 277.105 126.39V34.3996C277.105 33.5049 277.829 32.7792 278.723 32.7792C279.618 32.7792 280.344 33.5049 280.344 34.3996V126.39Z",
    fill: "#77787B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M277.742 69.9003H273.938V67.9273H277.742V69.9003Z",
    fill: "#444548"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M277.742 120.923H273.938V118.95H277.742V120.923Z",
    fill: "#444548"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M228.731 126.39C228.731 127.285 229.455 128.01 230.35 128.01C231.245 128.01 231.97 127.285 231.97 126.39V34.3996C231.97 33.5049 231.245 32.7792 230.35 32.7792C229.455 32.7792 228.731 33.5049 228.731 34.3996V126.39Z",
    fill: "#77787B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M231.333 69.9003H235.138V67.9273H231.333V69.9003Z",
    fill: "#444548"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M231.333 120.923H235.138V118.95H231.333V120.923Z",
    fill: "#444548"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M227.532 35.8365H233.168V27.7984C233.168 24.7431 235.656 22.2568 238.712 22.2568H257.713C259.979 21.6239 259.909 16.9729 257.713 16.6184H238.712C232.548 16.6184 227.532 21.6342 227.532 27.7984V35.8365Z",
    fill: "#6A6A6A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M289.44 185.286H219.599V181.047H289.44V185.286Z",
    fill: "#77787B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M259.383 16.7296V34.2264C257.79 34.1584 256.18 34.1419 254.534 34.1419C252.889 34.1419 251.279 34.1584 249.686 34.2264V16.7296C249.686 14.0846 251.84 13.6104 254.483 13.6104H254.586C257.231 13.6104 259.383 14.0846 259.383 16.7296Z",
    fill: "#303039"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M268.958 84.5149C268.958 92.4747 262.507 98.9276 254.547 98.9276C246.59 98.9276 240.137 92.4747 240.137 84.5149C240.137 76.5571 246.59 70.1044 254.547 70.1044C262.507 70.1044 268.958 76.5571 268.958 84.5149Z",
    fill: "#CC3333"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M264.278 84.515C264.278 89.8895 259.922 94.2477 254.548 94.2477C249.173 94.2477 244.817 89.8895 244.817 84.515C244.817 79.1424 249.173 74.7842 254.548 74.7842C259.922 74.7842 264.278 79.1424 264.278 84.515Z",
    fill: "#D65C5C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M257.11 84.515C257.11 85.9313 255.962 87.0775 254.547 87.0775C253.133 87.0775 251.987 85.9313 251.987 84.515C251.987 83.1007 253.133 81.9545 254.547 81.9545C255.962 81.9545 257.11 83.1007 257.11 84.515Z",
    fill: "#B21A1A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M266.903 85.4695H242.193V83.5625H266.903V85.4695Z",
    fill: "#B21A1A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M227.652 158.902H208.744V153.154H227.652V158.902Z",
    fill: "#77787B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M209.76 161.165H205.865V150.89H209.76V161.165Z",
    fill: "#444548"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M227.652 176.302H208.744V170.556H227.652V176.302Z",
    fill: "#77787B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M209.76 178.568H205.865V168.293H209.76V178.568Z",
    fill: "#444548"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M161.469 42.9007H147.75V35.5987H161.469V42.9007Z",
    fill: "#3F3F46"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M206.174 53.8979C206.174 46.3809 183.087 40.2869 154.608 40.2869C126.129 40.2869 103.041 46.3809 103.041 53.8979C103.041 61.4149 126.129 67.5089 154.608 67.5089C183.087 67.5089 206.174 61.4149 206.174 53.8979Z",
    fill: "#515159"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M107.108 51.7742H118.818C123.041 48.5391 132.394 44.8978 146.369 43.0814C124.831 43.9928 111.341 48.3521 107.108 51.7742Z",
    fill: "#3F3F46"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M151.226 42.9417C136.659 44.7065 126.957 48.4575 122.627 51.7742H129.378C133.708 48.4575 143.41 44.7065 157.978 42.9417C156.866 42.9224 155.759 42.9009 154.609 42.9009C153.453 42.9009 152.342 42.9224 151.226 42.9417Z",
    fill: "#3F3F46"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M200.728 175.976C200.728 167.796 180.07 161.165 154.588 161.165C129.107 161.165 108.449 167.796 108.449 175.976C108.449 184.157 129.107 190.788 154.588 190.788C180.07 190.788 200.728 184.157 200.728 175.976Z",
    fill: "#3F3F46"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M114.123 203.008H107.066V178.568H114.123V203.008Z",
    fill: "#77787B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M202.111 203.008H195.053V178.568H202.111V203.008Z",
    fill: "#77787B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M103.041 56.8384C103.015 57.105 103 57.3736 103 57.6466V182.078H206.175V57.6466C206.175 57.3736 206.16 57.105 206.134 56.8384H103.041Z",
    fill: "#303039"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M106.857 59.5341C106.819 59.7942 106.776 60.0543 106.776 60.3251V179.563H116.262V59.7727L116.279 59.5341H106.857Z",
    fill: "#3F3F46"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M119.818 59.534L119.801 59.7726V179.563H126.682V59.7726L126.699 59.534H119.818Z",
    fill: "#3F3F46"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M117.877 203.008H103.312V200.54H117.877V203.008Z",
    fill: "#444548"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M205.865 203.008H191.3V200.54H205.865V203.008Z",
    fill: "#444548"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M206.174 53.8979H103.041V56.8385H206.174V53.8979Z",
    fill: "#3F3F46"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M161.469 7.62939e-06H147.75V35.5988H161.469V7.62939e-06Z",
    fill: "#303039"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M112.917 141.733C112.917 142.771 113.758 143.61 114.794 143.61C115.831 143.61 116.671 142.771 116.671 141.733V35.1366C116.671 34.1005 115.831 33.26 114.794 33.26C113.758 33.26 112.917 34.1005 112.917 35.1366V141.733Z",
    fill: "#77787B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M115.931 76.2726H120.341V73.9877H115.931V76.2726Z",
    fill: "#444548"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M115.931 135.398H120.341V133.111H115.931V135.398Z",
    fill: "#444548"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M111.527 36.8025H118.06V27.4885C118.06 23.9482 120.942 21.0656 124.483 21.0656H147.768V14.5331H124.483C117.339 14.5331 111.527 20.3455 111.527 27.4885V36.8025Z",
    fill: "#6A6A6A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M153.005 34.625H149.412V1.1435H153.005V34.625Z",
    fill: "#3F3F46"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M155.894 34.625H154.098V1.14353H155.894V34.625Z",
    fill: "#3F3F46"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M175.695 112.179C175.695 123.836 166.245 133.285 154.588 133.285C142.931 133.285 133.481 123.836 133.481 112.179C133.481 100.522 142.931 91.0724 154.588 91.0724C166.245 91.0724 175.695 100.522 175.695 112.179Z",
    fill: "#CC3333"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M168.841 112.179C168.841 120.051 162.459 126.433 154.587 126.433C146.715 126.433 140.334 120.051 140.334 112.179C140.334 104.307 146.715 97.9252 154.587 97.9252C162.459 97.9252 168.841 104.307 168.841 112.179Z",
    fill: "#D65C5C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M158.34 112.179C158.34 114.251 156.661 115.93 154.588 115.93C152.517 115.93 150.837 114.251 150.837 112.179C150.837 110.107 152.517 108.428 154.588 108.428C156.661 108.428 158.34 110.107 158.34 112.179Z",
    fill: "#B21A1A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M172.685 113.576H136.492V110.782H172.685V113.576Z",
    fill: "#B21A1A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.75 44.0208C33.0282 44.0208 34.875 42.1739 34.875 39.8958C34.875 37.6176 33.0282 35.7708 30.75 35.7708C28.4718 35.7708 26.625 37.6176 26.625 39.8958C26.625 42.1739 28.4718 44.0208 30.75 44.0208Z",
    fill: "#7B7B7B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M378.75 52.0208C381.028 52.0208 382.875 50.1739 382.875 47.8958C382.875 45.6176 381.028 43.7708 378.75 43.7708C376.472 43.7708 374.625 45.6176 374.625 47.8958C374.625 50.1739 376.472 52.0208 378.75 52.0208Z",
    fill: "#7B7B7B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.75 157.146C4.26878 157.146 5.5 155.915 5.5 154.396C5.5 152.877 4.26878 151.646 2.75 151.646C1.23122 151.646 0 152.877 0 154.396C0 155.915 1.23122 157.146 2.75 157.146Z",
    fill: "#7B7B7B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M357.375 123.271C358.894 123.271 360.125 122.04 360.125 120.521C360.125 119.002 358.894 117.771 357.375 117.771C355.856 117.771 354.625 119.002 354.625 120.521C354.625 122.04 355.856 123.271 357.375 123.271Z",
    fill: "#7B7B7B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.375 147.271C24.4461 147.271 26.125 145.592 26.125 143.521C26.125 141.45 24.4461 139.771 22.375 139.771C20.3039 139.771 18.625 141.45 18.625 143.521C18.625 145.592 20.3039 147.271 22.375 147.271Z",
    fill: "#7B7B7B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTank);
export default __webpack_public_path__ + "static/media/emptyTank.c72c0609bf6b03ed0872babd54c95468.svg";
export { ForwardRef as ReactComponent };